/*!
  =========================================================
  * Muse Ant Design Dashboard - v1.0.0
  =========================================================
  * Product Page: https://www.creative-tim.com/product/muse-ant-design-dashboard
  * Copyright 2021 Creative Tim (https://www.creative-tim.com)
  * Licensed under MIT (https://github.com/creativetimofficial/muse-ant-design-dashboard/blob/main/LICENSE.md)
  * Coded by Creative Tim
  =========================================================
  * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { Menu } from "antd";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/ps-images/logo.png";
import {useSelector} from "react-redux";
import {getAuthenticatedUser} from "../../utils/authHelper";
import {
  UnorderedListOutlined,
  BarChartOutlined,
  SafetyCertificateOutlined,
  UserSwitchOutlined,
  UserOutlined,
} from "@ant-design/icons";

function Sidenav({ color }) {
  const amjUser = getAuthenticatedUser();
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  return (
    <>
      <div className="brand">
        <img src={logo} alt="" />
        <span>PSO-Accounts</span>
      </div>
      <hr />
      <Menu theme="light" mode="inline">
        {amjUser.isAdmin() ? <>
          <Menu.Item key="0">
            <NavLink to="/members">
            <span
                className="icon"
                style={{
                  background: page === "members" ? color : "",
                }}
            >
              <UnorderedListOutlined />
            </span>
              <span className="label">Members</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="1">
            <NavLink to="/statistics">
            <span
                className="icon"
                style={{
                  background: page === "statistics" ? color : "",
                }}
            >
              <BarChartOutlined />
            </span>
              <span className="label">Statistics</span>
            </NavLink>
          </Menu.Item>
          {amjUser.isRolesManager() && (
            <Menu.Item key="2">
              <NavLink to="/manage-roles">
              <span
                  className="icon"
                  style={{
                    background: page === "manage-roles" ? color : "",
                  }}
              >
                <SafetyCertificateOutlined />
              </span>
                <span className="label">Manage Roles</span>
              </NavLink>
            </Menu.Item>
          )}
            {/*todo need to gate this on if the loged is user is an Admin which techinical means has role of amj-international-admin 'PS Accounts App Admin'*/}
          <Menu.Item key="3">
            <NavLink to="/duplicate-accounts">
            <span
                className="icon"
                style={{
                  background: page === "duplicate-accounts" ? color : "",
                }}
            >
              <UserSwitchOutlined />
            </span>
              <span className="label">Duplicate Accounts</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item className="menu-item-header" key="5">
            Account Pages
          </Menu.Item>

        </>: ""}
        
        <Menu.Item key="6">
          <NavLink to="/profile">
            <span
              className="icon"
              style={{
                background: page === "profile" ? color : "",
              }}
            >
              <UserOutlined />
            </span>
            <span className="label">Profile</span>
          </NavLink>
        </Menu.Item>
      </Menu>
    </>
  );
}

export default Sidenav;